import { Box, Typography } from "@mui/material"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import React from "react"
import { useDateTime } from "../../../../../localization/useDateTime"
import { makeStyles } from "tss-react/mui"
import { ProductNumberHistory } from "../productNumbersTypes"

const useStyles = makeStyles()(() => ({
    historyContainer: {
        display: "flex",
        flexDirection: "column",
        gap: "2rem",
    },
    infoBox: {
        display: "flex",
        justifyContent: "space-between",
    },
}))

export function FormAsideHistoryContainer({ history }: { history: ProductNumberHistory }) {
    const { classes } = useStyles()
    const dateTimeFactory = useDateTime()

    const { created, updated } = history

    return (
        <Box className={classes.historyContainer}>
            <Box className={classes.infoBox}>
                <LocalizedStrict id="supplier-admin-erp-product-group-numbers-aside-created">
                    <Typography>Created: </Typography>
                </LocalizedStrict>
                <Box>
                    <Typography align="right">
                        {dateTimeFactory.formatDate(dateTimeFactory.fromApi(created.timestamp))}
                    </Typography>
                    <Typography textAlign="right">{created.author ?? "-"}</Typography>
                </Box>
            </Box>
            {updated?.timestamp && (
                <Box className={classes.infoBox}>
                    <LocalizedStrict id="supplier-admin-erp-product-group-numbers-aside-updated">
                        <Typography>Updated: </Typography>
                    </LocalizedStrict>
                    <Box>
                        <Typography align="right">
                            {dateTimeFactory.formatDate(dateTimeFactory.fromApi(updated.timestamp))}
                        </Typography>
                        <Typography textAlign="right">{updated.author ?? "-"}</Typography>
                    </Box>
                </Box>
            )}
        </Box>
    )
}
